import styled from 'styled-components';

export const SlideCard = styled.div`
  aspect-ratio: 3/2;
  border-radius: 14px;
  overflow: hidden;
  background: #f5f5f5;
  position: relative;
`;

export const SkeletonSlide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 14px;
`;

export const SlideImage = styled.img<{ $loaded?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  aspect-ratio: 3/2;
  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;

export const SlideButton = styled.button`
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  display: block;
  position: relative;
  &:focus-visible {
    outline: 2px solid var(--t-brand-fg-color, #1c1c1c);
    outline-offset: -2px;
  }
`;
